export const makeTrackPointerDrag = (doc)=>(param)=>{
        let { onMove, onEnd } = param;
        // WHY: a release outside the window never reaches the document; a move with no button held means it happened.
        const move = (event)=>event.buttons === 0 ? end() : onMove(event.clientX);
        const stop = ()=>{
            doc.removeEventListener('pointermove', move);
            doc.removeEventListener('pointerup', end);
            doc.removeEventListener('pointercancel', end);
        };
        const end = ()=>{
            stop();
            onEnd();
        };
        doc.addEventListener('pointermove', move);
        doc.addEventListener('pointerup', end);
        doc.addEventListener('pointercancel', end);
        return stop;
    };
